export default __webpack_public_path__ + "static/aics-logo-white-eae18a34b4910908d6e4487b6fcda377.png";